// 优先取浏览器外置配置，没有再读取环境变量
export function getApiBaseUrl() {
  if (window.__ENV__ && window.__ENV__.VUE_APP_API_BASE_URL) {
    return window.__ENV__.VUE_APP_API_BASE_URL
  }
  return process.env.VUE_APP_API_BASE_URL
}